import { useQuery } from '@tanstack/react-query';
import { ShopsApiAdapter, Shop } from '../adapters/ShopsApiAdapter';

export const useShops = () => {
  const shopsAdapter = new ShopsApiAdapter();

  const {
    data: shops,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['shops'],
    queryFn: () => shopsAdapter.getShops(1, 100),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    shops: shops?.data || [],
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
